
$(document).ready(function () {
    function validateField(field) { 
        var validation = false;
        if (field.attr('type') == 'email') {
            validation = validateEmail(field);
        } else if (field.attr('type') == 'password') {
            if (!field.hasClass('confirm-password')) {
                validation = validatePassword(field);
            } else {
                validation = validateConfirmPassword(field);
            }
        } else if (field.attr('type') == 'text') {
            if (field.hasClass('website-validation')) {
                validation = validateWebsite(field);
            } else {
                validation = validateText(field);
            }
        } else if (field[0]['localName'] === 'textarea'){
            validation = validateTextarea(field);
        } else if (field[0]['localName'] === 'select') {
            validation = validateSelect(field);
        } else if (field.attr('type') == 'tel') {
            validation = validatePhone(field);
        } else if (field.attr('type') == 'checkbox') {
            validation = validateCheckbox(field);
        } else if (field.attr('type') == 'file') {
            validation = validateFileUpload(field);
        } else if (field.attr('name') == 'fax') {
            validation = validateFax(field);
        } else if (field.attr('type') == 'number') {
            validation = validateNumber(field);
        }

        if (validation) {
            field.next('.form-validation-error').remove();
        }
        return validation;
    }

    function validateEmail(field) {
        if (!emptyCheck(field)) {
            return false;
        }

        const email = field.val()
        function invalidEmail() {
            field.next('.form-validation-error').remove();
            $('<span class="form-validation-error">Please enter a valid email address</span>').insertAfter(field);
        }

        const emailParts = email.split('@');
        if (emailParts.length != 2) {
            var sanitizedValue = field.val().replace(/[^a-zA-Z0-9._@]/g, '').replace(/\.{2,}/g, '.').replace(/_{2,}/g, '_');
            field.val(sanitizedValue);
            invalidEmail();
            return false;
        }else{
            var sanitizedValue = field.val().replace(/[^a-zA-Z0-9._/@-]/g, '').replace(/\.{2,}/g, '.').replace(/_{2,}/g, '_');
            field.val(sanitizedValue);
        }

        const localPart = emailParts[0];
        const domainPart = emailParts[1];
        // const regex = /^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+(\.[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+)*$/;
        const regex = /^[a-zA-Z0-9._]+$/;

        if (!regex.test(localPart) || localPart.length > 64 || localPart.startsWith('.') || localPart.endsWith('.') || localPart.includes('..')) {
            invalidEmail();
            return false;
        }

        if (domainPart.includes('--') || domainPart.startsWith('-') || domainPart.endsWith('-') || domainPart.length > 255) {
            invalidEmail();
            return false;
        }

        const tldRegex = /^[a-zA-Z]{2,}$/;
        const domainParts = domainPart.split('.');
        const domainNameRegex = /^[a-zA-Z0-9]+([-][a-zA-Z0-9]+)*$/;

        if (!domainNameRegex.test(domainParts[0])) {
            invalidEmail();
            return false;
        }

        if (
            domainParts.length < 2 ||
            !tldRegex.test(domainParts[domainParts.length - 1])
        ) {
            invalidEmail();
            return false;
        }

        for (let i = 0; i < domainParts.length - 1; i++) {
            if (!domainNameRegex.test(domainParts[i])) {
                invalidEmail();
                return false;
            }
        }

        field.next('.form-validation-error').remove();
        return true;
    }

    function validatePassword(field) {
        if (field.hasClass('validate-password')) {
            if (field.val() !== '' && (field.val().length < 8 || field.val().length > 40)) {
                field.next('.form-validation-error').remove();
                $('<span class="form-validation-error">Password must be between 8 and 40 characters long</span>').insertAfter(field);
                return false;
            }
        }

        return emptyCheck(field);
    }

    function validateConfirmPassword(field) {
        if (field.val() != "" && (field.val() != field.closest('form').find('#password').val())) {
            field.next('.form-validation-error').remove();
            $('<span class="form-validation-error">Password does not match</span>').insertAfter(field);
            return false;
        }
        return emptyCheck(field);
    }

    function validateText(field) {
        if (
            field.val().length < 3 &&
            field.val() !== '' &&
            field.hasClass('min-3-characters')
        ) {
            field.next('.form-validation-error').remove();
            $('<span class="form-validation-error">Please enter at least 3 characters</span>').insertAfter(field);
            return false;
        }

        if(field.hasClass('name-validation')){
            var sanitizedValue = field.val().replace(/\s{2,}/g, ' ').replace(/([-,.€~!@#$%^&*()_+=`{}\[\]\|\\:;'<>\/])+/g, '').replace(/\d+/,'').replace(/[^a-zA-Z\s]/g, "");;
            field.val(sanitizedValue);
        }

        if (
            field.val().length > 56 &&
            field.val() !== '' &&
            field.hasClass('max-56-characters')
        ) {
            field.val(field.val().substring(0, 56));
            field.next('.form-validation-error').remove();
            $('<span class="form-validation-error">Maximum of 56 characters allowed</span>').insertAfter(field);
            return false;
        }

        if (
            field.val().length > 40 &&
            field.val() !== '' &&
            field.hasClass('max-40-characters')
        ) {
            field.val(field.val().substring(0, 40));
            field.next('.form-validation-error').remove();
            $('<span class="form-validation-error">Maximum of 40 characters allowed</span>').insertAfter(field);
            return false;
        }

        if (
            field.val().length > 100 &&
            field.val() !== '' &&
            field.hasClass('max-100-characters')
        ) {
            field.val(field.val().substring(0, 100));
            field.next('.form-validation-error').remove();
            $('<span class="form-validation-error">Maximum of 100 characters allowed</span>').insertAfter(field);
            return false;
        }

        if (
            field.val().length > 255 &&
            field.val() !== '' &&
            field.hasClass('max-255-characters')
        ) {
            field.val(field.val().substring(0, 255));
            field.next('.form-validation-error').remove();
            $('<span class="form-validation-error">Maximum of 255 characters allowed</span>').insertAfter(field);
            return false;
        }
        return emptyCheck(field);
    }

      // function validateText(field) {
      //   const value = field.val().trim();
        
      //   // Function to show validation errors
      //   function showError(message) {
      //       field.next('.form-validation-error').remove();
      //       $(`<span class="form-validation-error">${message}</span>`).insertAfter(field);
      //       return false;
      //   }
    
      //   // Check for numbers (not allowed)
      //   if (/[0-9]/.test(value)) {
      //       return showError('Numbers are not allowed');
      //   }
    
      //   // Check for hyphens (not allowed)
      //   if (/-/.test(value)) {
      //       return showError('Hyphens are not allowed');
      //   }
    
      //   // Check for special characters (only allow letters and spaces)
      //   if (!/^[a-zA-Z\s]*$/.test(value)) {
      //       return showError('Only letters and spaces are allowed');
      //   }
    
      //   // Check for consecutive spaces
      //   if (/\s{2,}/.test(value)) {
      //       return showError('Multiple consecutive spaces are not allowed');
      //   }
    
      //   // Check maximum length of 56 characters (unless a different max is specified via class)
      //   if (value.length > 56 && !field.hasClass('max-40-characters') && 
      //       !field.hasClass('max-100-characters') && !field.hasClass('max-255-characters')) {
      //       return showError('Maximum of 56 characters allowed');
      //   }
    
      //   // Existing length validations
      //   if (value.length < 3 && value !== '' && field.hasClass('min-3-characters')) {
      //       return showError('Please enter at least 3 characters');
      //   }
    
      //   if (value.length > 40 && value !== '' && field.hasClass('max-40-characters')) {
      //       field.val(value.substring(0, 40));
      //       return showError('Maximum of 40 characters allowed');
      //   }
    
      //   if (value.length > 100 && value !== '' && field.hasClass('max-100-characters')) {
      //       field.val(value.substring(0, 100));
      //       return showError('Maximum of 100 characters allowed');
      //   }
    
      //   if (value.length > 255 && value !== '' && field.hasClass('max-255-characters')) {
      //       field.val(value.substring(0, 255));
      //       return showError('Maximum of 255 characters allowed');
      //   }
    
      //   return emptyCheck(field);
      // }

    function validateWebsite(field) {
        let website = field.val();

        if (website.length > 255) {
            field.next('.form-validation-error').remove();
            $('<span class="form-validation-error">Website URL must be at most 255 characters</span>').insertAfter(field);
            return false;
        }
        const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/; // Structure
        if (urlRegex.test(website)) {
            field.next('.form-validation-error').remove();
            return true;
        } else {
            field.next('.form-validation-error').remove();
            $('<span class="form-validation-error">Please enter a valid URL</span>').insertAfter(field);
            return false;
        }
    }

    function validateTextarea(field) {
        if (field.hasClass('max-1200-characters')) {
            if(field.val().length > 1200 && field.val() !== ''){
                field.val(field.val().substring(0, 1200));
                field.next('.form-validation-error').remove();
                $('<span class="form-validation-error">Maximum of 1200 characters allowed</span>').insertAfter(field);
                return false;
            }else{
                field.next('.form-validation-error').remove();
            } 
        }
        return emptyCheck(field);
    }
  

    function validateSelect(field) {
        return emptyCheck(field);
    }

    // function validatePhone(field) {
    //     if (!emptyCheck(field)) {
    //         return false;
    //     }

    //     const phone = field.val();

    //     function invalidPhone() {
    //         field.next('.form-validation-error').remove();
    //         $('<span class="form-validation-error">Please enter a valid phone number</span>').insertAfter(field);
    //     }

    //     if (phone.length < 6 || phone.length > 14) {
    //         invalidPhone();
    //         return false;
    //     }

    //     field.next('.form-validation-error').remove();
    //     return true;
    // }
     function validatePhone(field) {
        if (!emptyCheck(field)) {
            return false;
        }
    
        const phone = field.val().trim();
        
     
        const cleanedPhone = phone.replace(/\D/g, '')
        
        function invalidPhone(message = 'Please enter a valid phone number') {
            field.next('.form-validation-error').remove();
            $(`<span class="form-validation-error">${message}</span>`).insertAfter(field);
            return false;
        }
    
       
        if (cleanedPhone.length < 10 || cleanedPhone.length > 11) {
            return invalidPhone('Please enter a valid phone number');
        }
    
       
        if (!/^\d+$/.test(cleanedPhone)) {
            return invalidPhone('Please enter a valid phone number');
        }
    
        
        if (/^0+$/.test(cleanedPhone)) {
            return invalidPhone('Please enter a valid phone number');
        }
    
       
        if (/^10+$/.test(cleanedPhone)) {
            return invalidPhone('Please enter a valid phone number');
        }
    
        field.next('.form-validation-error').remove();
        return true;
    }
   
    function validateFax(field) {
        if (!emptyCheck(field)) {
            return false;
        }
        let fax = field.val();

        function invalidFax() {
            field.next('.form-validation-error').remove();
            $('<span class="form-validation-error">Please enter a valid fax number</span>').insertAfter(field);
        }

        if (fax.length < 7 || fax.length > 20) {
            invalidFax();
            return false;
        }
        const faxRegex = /^(\+?\d{1,4})?[\s-]?(\(?\d{2,4}\)?)?[\s-]?\d{3,4}[\s-]?\d{4}$/; // Structure
        if (faxRegex.test(fax)) {
            field.next('.form-validation-error').remove();
            return true;
        } else {
            invalidFax();
            return false;
        }
    }

    function validateNumber(field) {
        return emptyCheck(field);
    }

    function validateCheckbox(field) {
        return emptyCheck(field);
    }

    function validateFileUpload(field) {
        if (!emptyCheck(field)) {
            return false;
        }

        if (field[0].files.length != 0) {
            var fileName = field[0].files[0].name;

            var uploadFileName = field.closest('.upload-wrapp').find('.upload-text');

            if (fileName != '') {
                uploadFileName.text(fileName);

                uploadFileName.addClass('upload-text-color');

                var fileSize = field[0].files[0].size;

                var fileSizeMB = fileSize / (1024 * 1024);

                if (fileSizeMB > 2) {
                    field.next('.form-validation-error').remove();

                    $('<span class="form-validation-error">The uploaded file is too large</span>').insertAfter(field);

                    return false;
                } else {
                    return true;
                }
            }
        }
    }

    $(document).on('input keypress', '.contact__form input, .contact__form textarea, ' +
  '#customer_login input, .recover_customer_password input, ' +
  '#create_customer input, .update-address input, .add-address input, ' +
  '#ContactForm input, #ContactForm textarea, .reset-password input, .cart__note textarea', function (e) {
        let trimmedValue = $(this).val().trim();
        let inputValue = $(this).val();

        if (!trimmedValue.replace(/\s/g, '').length) {
            $(this).val('');
        }

        if (e.key === ' ' && trimmedValue.length === 0) {
            e.preventDefault();
            $(this).val('');
        }

        if (trimmedValue.length < inputValue.length) {
            if (/^\s/.test(inputValue)) {
                $(this).val(trimmedValue);
            }
        }

        if ($(this).attr('type') === 'tel' || $(this).attr('type') === 'number') {
            let trimmedValue = $(this).val().trim();
            let isNumber = /[0-9\-+]/.test(e.key);
            if (!isNumber && trimmedValue.length === 0) {
                e.preventDefault();
                $(this).val('');
            }

            if (!isNumber) {
                e.preventDefault();
            }
        }


        if ($(this).attr('type') === 'text' && $(this).attr('data-field') !== 'zip') {
            let trimmedValue = $(this).val().trim();

            // Check if the pressed key is a letter (excluding numbers and special characters)
            let isLetter = /^[a-zA-Z]+$/.test(e.key);

            // If the pressed key is not a letter and the input value is empty
            if (!isLetter && trimmedValue.length === 0) {
                e.preventDefault();
                $(this).val('');
            }
        }

        // Allow only letters, numbers, and hyphens in the zip code field
        if ($(this).attr('type') === 'text' && $(this).attr('data-field') == 'zip') {    
            if(!/^[A-Za-z0-9-]+$/.test(e.key)){
                e.preventDefault();
            }
        }

        // var myArray = ['password', 'file'];
        // if ($.inArray($(this).attr('type'), myArray) != 0) {
        //     var sanitizedValue = inputValue.replace(/\s{2,}/g, ' ') // Replace consecutive spaces with a single space

        //     $(this).val(sanitizedValue);
        // }

        if ($(this).hasClass('required')) {
            if ($(this).val() == '') {
                emptyCheck($(this));
            } else {
                $(this).next('.form-validation-error').remove();

                if ($(this).attr('type') === 'email') {
                    validateEmail($(this));
                } else if ($(this).attr('type') === 'tel') {
                    validatePhone($(this));
                } else if ($(this).attr('type') === 'text') {
                    if ($(this).hasClass('website-validation')) {
                        validateWebsite($(this));
                    } else {
                        validateText($(this));
                    }
                } else if ($(this)[0]['localName'] === 'textarea'){
                    validateTextarea($(this));
                } else if ($(this).attr('type') == 'file') {
                    validateFileUpload($(this));
                } else if ($(this).attr('type') == 'password') {
                    if (!$(this).hasClass('confirm-password')) {
                        validatePassword($(this));
                    } else {
                        validateConfirmPassword($(this));
                    }
                } else if ($(this).attr('type') == 'number') {
                    validateNumber($(this));
                }
            }
        } else if (!$(this).hasClass('required') && $(this).val() !== '') {
            if ($(this).attr('type') === 'email') {
                validateEmail($(this));
            } else if ($(this).attr('type') === 'tel') {
                validatePhone($(this));
            } else if ($(this).attr('type') === 'text') {
                validateText($(this));
            } else if ($(this).attr('type') == 'file') {
                validateFileUpload($(this));
            } else if ($(this).attr('name') == 'fax') {
                validateFax($(this));
            } else if ($(this).attr('type') == 'number') {
                validateNumber($(this));
            } else if ($(this)[0]['localName'] === 'textarea'){
                validateTextarea($(this));
            }
    }
    });

    $(document).on('click', '.contact__form button[type="submit"], #customer_login button, .recover_customer_password button, #create_customer button, .add-address button, .update-address button, #ContactForm button[type="submit"], .reset-password button', function (e) {
        var validated = false;
        var validationSuccess = true;
        var flag = 0;

        $(this).closest('form').find('input.required:not([type="hidden"]):not([type="submit"]), textarea.required, select.required').each(function () {
            validated = validateField($(this));
            if (!validated) {
                validationSuccess = false;
                if (flag == 0) {
                    $(this).focus();
                    flag = 1;
                }
            }
        })

        if (!validationSuccess) {
            e.preventDefault();
        }

        // if($(this).closest('form').hasClass('contact__form')){
        //     $(this).closest('form').find('.contact__button').append('<div class="contact-form-loader"></div>');
        // }
    });

    // $('.newsletter-form').on('submit', function (e) {
    //     $(this).find('button[type="submit"]').trigger('clcik');
    // });


    $(document).on('focusout', "input:not([type='file']).required, select.required, textarea.required", function () {
        emptyCheck($(this));
    });

    $('select').on('change', function () {
        if ($(this).val() !== '') {
            $(this).next('.form-validation-error').remove();
        }
    });

    function emptyCheck(field) {
        let fieldName = ''
        fieldName = field.attr('data-label');

        if (((field[0]['localName'] === 'select' && field.attr('multiple') == 'multiple' && field.val().length == 0) || (field.val() === '' || field.val() === null)) && field.hasClass('required')) {
            field.next('.form-validation-error').remove();
            if (fieldName) {
                fieldName = fieldName.replace('*', '');
            }

            $('<span  role="alert" aria-live="assertive" class="form-validation-error" role="alert" aria-live="assertive">' + fieldName + ' is required</span>').insertAfter(field);
            return false;
        } else {
            return true;
        }
    }

    setTimeout(() => {
       $('body.template-customers-account, body.template-customers-addresses').find('#profile_update').closest('div').css('display', 'none'); 
    }, 1500);

  
   $(document).on('input keydown paste', '.quantity__input', function(e) {
        var $input = $(this);
        var maxval = parseInt($input.attr('max')) || 100;
        var minval = parseInt($input.attr('min')) || 1;
        var currentVal = parseInt($input.val()) || minval;

        // Handle paste event
        if (e.type === 'paste') {
            setTimeout(function() {
                var pastedValue = $input.val();
                if (!/^\d+$/.test(pastedValue)) {
                    $input.val(currentVal);
                    $input.closest('.product__submit-form').find('.product-form__error-message-wrapper').removeAttr('hidden');
                    $input.closest('.cart-item__details').find('.cart-item__error-text').text('Only numbers are allowed');
                    $input.closest('.product__submit-form').find('.product-form__error-message').text('Only numbers are allowed');
                    setTimeout(function() {
                        $input.closest('.product__submit-form').find('.product-form__error-message-wrapper').attr('hidden', true);
                    }, 2000);
                }
            }, 0);
            return;
        }

        // Handle key events
        if (e.type === 'keydown') {
            // Allow special keys
            if ([46, 8, 9, 27, 13, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
                ((e.ctrlKey || e.metaKey) && [65, 67, 86, 88].indexOf(e.keyCode) !== -1)) {
            return;
            }
            
            // Block non-numeric keys
            if ((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
            $input.closest('.product__submit-form').find('.product-form__error-message-wrapper').removeAttr('hidden');
            $input.closest('.cart-item__details').find('.cart-item__error-text').text('Only numbers are allowed');
            $input.closest('.product__submit-form').find('.product-form__error-message').text('Only numbers are allowed');
            setTimeout(function() {
                $input.closest('.product__submit-form').find('.product-form__error-message-wrapper').attr('hidden', true);
            }, 2000);
            return;
            }
        }

        // Handle input validation
        if (e.type === 'input') {
            // Remove any non-numeric characters
            $input.val($input.val().replace(/[^0-9]/g, ''));
            
            currentVal = parseInt($input.val()) || minval;
            
            // Validate against min/max
            if (currentVal > maxval) {
            $input.closest('.product__submit-form').find('.product-form__error-message-wrapper').removeAttr('hidden');
            $input.closest('.cart-item__details').find('.cart-item__error-text').text('Maximum quantity allowed is ' + maxval);
            $input.closest('.product__submit-form').find('.product-form__error-message').text('Maximum quantity allowed is ' + maxval);
            $input.val(maxval);
            setTimeout(function() {
                $input.closest('.product__submit-form').find('.product-form__error-message-wrapper').attr('hidden', true);
            }, 2000);
            } else if (currentVal < minval) {
            $input.closest('.product__submit-form').find('.product-form__error-message-wrapper').removeAttr('hidden');
            $input.closest('.cart-item__details').find('.cart-item__error-text').text('Maximum quantity allowed is ' + minval);
            $input.closest('.product__submit-form').find('.product-form__error-message').text('Maximum quantity allowed is ' + minval);
            $input.val(minval);
            setTimeout(function() {
                $input.closest('.product__submit-form').find('.product-form__error-message-wrapper').attr('hidden', true);
            }, 2000);
            } else {
            $input.closest('.product__submit-form').find('.product-form__error-message-wrapper').attr('hidden', true);
            }
        }
    });

  
    $(document).on('input keydown paste', '.facets__price .field__input', function(e) {
    var $input = $(this);
    var maxval = parseFloat($input.attr('max')) || 47189.00;
    var minval = parseFloat($input.attr('min')) || 0.00;
    var currentVal = parseFloat($input.val()) || minval;
    var isDecimal = $input.attr('type') === 'number' && $input.attr('step') !== '1';

    // Handle paste event
    if (e.type === 'paste') {
        setTimeout(function() {
        var pastedValue = $input.val();
        if (!/^\d*\.?\d*$/.test(pastedValue)) {
            $input.val(currentVal);
            showPriceError('Only numbers and decimals are allowed');
        }
        }, 0);
        return;
    }

    // Handle key events
    if (e.type === 'keydown') {
        // Allow: backspace, delete, tab, escape, enter, arrows
        if ([46, 8, 9, 27, 13, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
            ((e.ctrlKey || e.metaKey) && [65, 67, 86, 88].indexOf(e.keyCode) !== -1)) {
        return;
        }
        
        // Allow decimal point only once for decimal fields
        if (e.keyCode === 190 && isDecimal) {
        if ($input.val().indexOf('.') !== -1) {
            e.preventDefault();
        }
        return;
        }
        
        // Block non-numeric keys
        if ((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
        showPriceError('Only numbers are allowed');
        return;
        }
    }

    // Handle input validation
    if (e.type === 'input') {
        // Remove any non-numeric characters (allow decimal for price fields)
        $input.val($input.val().replace(/[^0-9.]/g, ''));
        
        // Ensure only one decimal point
        if (isDecimal) {
        var decimalSplit = $input.val().split('.');
        if (decimalSplit.length > 2) {
            $input.val(decimalSplit[0] + '.' + decimalSplit[1]);
        }
        }
        
        currentVal = parseFloat($input.val()) || minval;
        
        // Validate against min/max
        if (currentVal > maxval) {
        showPriceError('Maximum price is ₹' + maxval.toFixed(2));
        $input.val(maxval.toFixed(2));
        } else if (currentVal < minval) {
        showPriceError('Minimum price is ₹' + minval.toFixed(2));
        $input.val(minval.toFixed(2));
        }
    }
    });

    function showPriceError(message) {
    // Create or find error element
    var $error = $input.closest('price-range').find('.price-error');
    if ($error.length === 0) {
        $error = $('<div class="price-error text-xs text-red-500 mt-1"></div>');
        $input.closest('price-range').append($error);
    }
    
    $error.text(message).show();
    setTimeout(function() {
        $error.fadeOut();
    }, 2000);
    }  
    
    $('.customer.account a[href="/account/logout"]').on('click', function (event) {
		var confirmation = confirm("Are you sure you want to log out?");

		if (!confirmation) {
			event.preventDefault();
		}
	});
  
    $('.recover_customer_password a[href="#login"]').on('click', function () {
        $(this).closest('.recover_customer_password').find('#RecoverEmail').val('');
    });

    $(document).on('click', '.btn-remove-cart-item', function () {
        setTimeout(() => {
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    if (cart.item_count === 0 && cart.note) {
                        fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ note: '' })
                        });
                    }
            });
        }, 500); // Delay to wait for item removal to complete
    });
    
});
